import {createRouter, createWebHistory} from '@ionic/vue-router';
import store from "../store/index";
import auth from "@/middleware/auth";
import ToastService from "@/services/ToastService";
import { persistRouteHistory } from '@/views/extra/routeHistory';

const ROUTES_THAT_CLEAR_HISTORY = ['/complete-profile'];

/** Root pages: history stack is reset to [this page] when navigating to them. */
const ROOT_PAGES = ['/home', '/circles', '/friends', '/events', '/send'];

function updateRouteHistoryForNavigation(to, from) {
  let routeHistory = [...(store.state.navigation?.routeHistory || [])];
  const idx = routeHistory.indexOf(to.fullPath);
  if (idx !== -1) routeHistory = routeHistory.slice(0, idx);
  if (from.fullPath !== '/') routeHistory.push(to.fullPath);
  store.commit('navigation/SET_ROUTE_HISTORY', routeHistory);
}

let routes;
routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/login/LoginPage.vue')
    },
    {
        path: '/',
        name: 'Login',
        component: () => import('../views/login/LoginPage.vue')
    },
    /* {
        path: '/superLogin',
        name: 'SuperLogin',
        component: () => import('../views/login/SuperLoginPage.vue')
    }, */
    {
        path: '/user/auth/:token',
        name: 'UserAuth',
        component: () => import ('../views/login/UserAuth.vue'),

    },
    /*{
        path: '/register',
        name: 'Register',
        component: () => import('../views/login/registerUser.vue')
    },*/
    {
        path: '/register/:token',
        name: 'RegisterViaInvitation',
        component: () => import('../views/login/registerUserViaInvitation.vue')
    },
    {
        path: '/verification/:token',
        name: 'UserVerification',
        component: () => import ('../views/login/UserVerification.vue'),

    },
    {
        path: '/verification/step1/:token',
        name: 'UserVerification1',
        component: () => import ('../views/login/UserVerification1.vue'),

    },
    {
        path: '/verification/step2/:token',
        name: 'UserVerification2',
        component: () => import ('../views/login/UserVerification2.vue'),

    },
    {
        path: '/verification/merge/:token',
        name: 'UserMergeVerification',
        component: () => import ('../views/login/UserMergeVerification.vue'),

    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import ('../views/login/ForgotPassword.vue'),

    },
    {
        path: '/reset-password/:token',
        name: 'ResetPassword',
        component: () => import ('../views/login/ResetPassword.vue'),

    },
    {
        path: '/session-expired',
        name: 'SessionExpired',
        component: () => import ('../views/user/sessionExpired.vue'),

    },
    {
        path: '/link/:token',
        name: 'LinkVerification',
        component: () => import ('../views/login/LinkVerification.vue'),

    },
    {
        path: '/redeem/:code',
        name: 'RedeemGift',
        component: () => import ('../views/extra/RedeemGift.vue'),
    },
    {
        path: '/r/:code',
        name: 'RGift',
        component: () => import ('../views/extra/RedeemGift.vue'),
    },
    {
        path: '/gift/preview/:code',
        name: 'GiftPreview',
        component: () => import ('../views/extra/PreviewGift.vue'),
    },
    {
        path: '/event/preview/:code',
        name: 'EventPreview',
        component: () => import ('../views/extra/PreviewEvent.vue'),
        // component: () => import ('../views/extra/PreviewGuestEvent.vue'),
    },
    {
        path: '/event/guest/:code',
        name: 'EventGuestPreview',
        component: () => import ('../views/extra/PreviewGuestEvent.vue'),
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import ('../views/home/HomePage.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/account/gifts',
        name: 'MyGifts',
        component: () => import ('../views/home/MyGiftPage.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/account/more',
        name: 'MoreSettings',
        component: () => import ('../views/user/MorePage.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/circles',
        name: 'Dashboard',
        component: () => import ('../views/home/CirclePage.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/complete-profile',
        name: 'CompleteProfile',
        component: () => import ('../views/user/CompleteProfile.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/complete-profile/step1',
        name: 'CompleteProfile1',
        component: () => import ('../views/user/CompleteProfile1.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/complete-profile/step2',
        name: 'CompleteProfile2',
        component: () => import ('../views/user/CompleteProfile2.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/complete-profile/step3',
        name: 'CompleteProfile3',
        component: () => import ('../views/user/CompleteProfile3.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/circle/:id',
        name: 'GroupInfo',
        component: () => import ('../views/groups/GroupInfo.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/circle/:id/trash',
        name: 'GroupTrash',
        component: () => import ('../views/groups/GroupTrash.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/circle/setting/:id',
        name: 'GroupSetting',
        component: () => import ('../views/groups/GroupSetting.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/circle/shared/gift/:id',
        name: 'SharedGiftInfo',
        component: () => import ('../views/pool/SharedGiftDetails.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/circle/business/setting/:id',
        name: 'BusinessGroupSetting',
        component: () => import ('../views/bussiness/GroupSetting.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/circle/gift/:id',
        name: 'PoolInfo',
        component: () => import ('../views/pool/PoolDetails.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/circle/gift/edit/:id',
        name: 'GiftEdit',
        component: () => import ('../views/sendGift/EditSharedGift.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/circle/business/:id',
        name: 'BussinessGroupInfo',
        component: () => import ('../views/bussiness/GroupInfo.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/circle/business/gift/:id',
        name: 'BussinessPoolInfo',
        component: () => import ('../views/bussiness/PoolDetails.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/circle/business/receive/gift/:id',
        name: 'BussinessPoolInfoReceive',
        component: () => import ('../views/bussiness/PoolDetailsReceiver.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/circle/individual/:id',
        name: 'IndividualGiftInfo',
        component: () => import ('../views/individual/IndividualInfo.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/individual/gift/:id',
        name: 'IndividualDirectInfo',
        component: () => import ('../views/individual/IndividualDirectInfo.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/individual/shared/:id',
        name: 'IndividualSharedInfo',
        component: () => import ('../views/individual/IndividualSharedInfo.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/individual/campaign/:campaignId',
        name: 'IndividualCampaignInfo',
        component: () => import ('../views/individual/IndividualCampaignInfo.vue'),
        meta: {
            middleware: [auth]
        },
    },
    {
        path: '/friends',
        name: 'FriendsList',
        component: () => import ('../views/friends/FriendsList.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/send',
        name: 'SendOptions',
        component: () => import ('../views/sendGift/SendOptions.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/send/gift',
        name: 'SendGift',
        component: () => import ('../views/sendGift/SendGiftDirect.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/send/sharedGift',
        name: 'SendSharedGift',
        component: () => import ('../views/sendGift/SendGiftShared.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/send/campaign/create',
        name: 'CreateCampaign',
        component: () => import ('../views/campaign/createCampaign.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/campaign/:groupId/:campaignId',
        name: 'SendGiftCampaign',
        component: () => import ('../views/campaign/sendGiftCampaign.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/myProfile',
        name: 'MyProfile',
        component: () => import ('../views/user/myProfile.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/addressBook',
        name: 'AddressBook',
        component: () => import ('../views/user/addressBook.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account',
        name: 'ProfileOption',
        component: () => import ('../views/user/userOption.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/deposit/success/:id',
        name: 'depositSuccess',
        component: () => import ('../views/user/depositSuccess.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/deposit/cancel',
        name: 'depositCancel',
        component: () => import ('../views/user/depositCancel.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/deposit',
        name: 'deposit',
        component: () => import ('../views/user/deposit.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/redeem',
        name: 'redeem',
        component: () => import ('../views/user/withdraw.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/myWishlist',
        name: 'MyWishlist',
        component: () => import ('../views/user/myWishlist.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/holidayList',
        name: 'MyHolidayList',
        component: () => import ('../views/user/holidayList.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/birthday',
        name: 'Birthday',
        component: () => import ('../views/user/Birthday.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/wallet',
        name: 'Wallet',
        component: () => import ('../views/user/wallet.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/transactionList',
        name: 'TransactionList',
        component: () => import ('../views/user/transactionList.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/setting',
        name: 'Setting',
        component: () => import ('../views/user/setting.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/manageAccounts',
        name: 'ManageAccounts',
        component: () => import ('../views/user/manageAccounts.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/pay/zelle',
        name: 'ZellePayment',
        component: () => import ('../views/user/zellePay.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/pay/qrcode',
        name: 'ORCode',
        component: () => import ('../views/user/qrcode.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/user/info',
        name: 'MyInfo',
        component: () => import ('../views/user/userInfo.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/changePassword',
        name: 'ChangePassword',
        component: () => import ('../views/login/ChangePassword.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/account/report',
        name: 'GiftReport',
        component: () => import ('../views/sendGift/GiftReport.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/events',
        name: 'EventsList',
        component: () => import ('../views/events/EventList.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/event/:eventId',
        name: 'EventDetails',
        component: () => import ('../views/events/EventDetails.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/event/edit/:id',
        name: 'EditEvent',
        component: () => import ('../views/events/EditEvent.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/create/event',
        name: 'CreateEvent',
        component: () => import ('../views/events/CreateEvent.vue'),
        meta: {
            middleware:[auth]
        },
    },
    {
        path: '/individual/archived',
        name: 'IndividualArchived',
        component: () => import ('../views/individual/IndividualArchived.vue'),
        meta: {
            middleware:[auth]
        },
    }

];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})
router.beforeEach(async (to, from, next) => {
    if (!to.meta.middleware) {
        return next();
    }
    const middleware = to.meta.middleware;
    const context = { to, from, next, store };

    ToastService.dismiss();

    if (ROUTES_THAT_CLEAR_HISTORY.includes(to.fullPath)) {
        store.dispatch('navigation/clearRouteHistory');
        await persistRouteHistory(store);
    } else if (ROOT_PAGES.includes(to.fullPath)) {
        store.dispatch('navigation/setRouteHistory', [to.fullPath]);
        await persistRouteHistory(store);
    } else if (to.fullPath !== '/account/myProfile' || from.fullPath !== '/') {
        updateRouteHistoryForNavigation(to, from);
        await persistRouteHistory(store);
    }

    return middleware[0]({ ...context });
});
export default router
